// src/utils/retry.js
// Wraps any async API call and retries it if it fails due to
// network/cold-start issues (not for real 4xx/5xx logic errors).
export async function withRetry(fn, { retries = 2, delayMs = 1500 } = {}) {
  let lastError;

  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      return await fn();
    } catch (err) {
      lastError = err;

      const isNetworkIssue =
        !err.response || // axios sets this when there's no response at all
        err.code === "ECONNABORTED" ||
        err.message?.toLowerCase().includes("network");

      // Don't retry real errors like 401/403/404/500 — only network/cold-start blips
      if (!isNetworkIssue || attempt === retries) {
        throw err;
      }

      await new Promise((resolve) => setTimeout(resolve, delayMs));
    }
  }

  throw lastError;
}